import { render, staticRenderFns } from "./WalletParentDialog.vue?vue&type=template&id=c8a8df3c&scoped=true"
import script from "./WalletParentDialog.vue?vue&type=script&lang=js"
export * from "./WalletParentDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletParentDialog.vue?vue&type=style&index=0&id=c8a8df3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a8df3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a8df3c')) {
      api.createRecord('c8a8df3c', component.options)
    } else {
      api.reload('c8a8df3c', component.options)
    }
    module.hot.accept("./WalletParentDialog.vue?vue&type=template&id=c8a8df3c&scoped=true", function () {
      api.rerender('c8a8df3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Wallet/WalletParentDialog.vue"
export default component.exports